export const deepClone = <T>(obj: T) => JSON.parse(JSON.stringify(obj));
